/* PDP formula grid — filter tabs, show-more, ingredient detail bubble.
   Ported from V4F7BelowFold.tsx + bal-home-ingredient-bubble.js @ 94cc6d6 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getHeaderOffset() {
    var header = document.querySelector(
      '.bal-header, .v4-header, .shopify-section-group-header-group .bal-header-chrome',
    );
    if (header) {
      return header.getBoundingClientRect().bottom + 16;
    }
    var root = document.documentElement;
    var headerH =
      parseFloat(getComputedStyle(root).getPropertyValue('--v4-header-h')) ||
      parseFloat(getComputedStyle(root).getPropertyValue('--bal-header-h')) ||
      72;
    return headerH + 16;
  }

  /* visual-ingredient-fix-1002: fixed bars along the bottom edge (the PDP sticky Add-to-Cart bar is
     ~138px on phones) covered the end of the detail card, including its study citations. Measure what is
     actually pinned to the bottom of the viewport right now and keep the card clear of it. */
  function getBottomOffset() {
    /* offsetHeight is the bar's layout height, unaffected by its slide-in transform, so a bar that is still
       animating in (or about to, as the page scrolls past the buy box) is reserved in full. The formula grid
       sits far below the buy box, where the bar is always shown. */
    var covered = 0;
    var bar = document.getElementById('v4-pdp-sticky-bar');
    if (bar && getComputedStyle(bar).display !== 'none') {
      covered = bar.offsetHeight || 0;
    }
    return covered + 24;
  }

  /** After the bubble expand animation, scroll so the full detail card is visible. */
  function scrollBubbleIntoView(bubbleEl) {
    if (!bubbleEl) return;

    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    // Match CSS grid-template-rows transition (~360ms) so height is final before measuring.
    var delay = prefersReducedMotion() ? 60 : 420;

    window.setTimeout(function () {
      var card = bubbleEl.querySelector('.v4-ingredient-bubble__card');
      if (!card) return;

      var padTop = getHeaderOffset();
      var padBottom = getBottomOffset();
      var rect = card.getBoundingClientRect();
      var viewH = window.innerHeight;
      var avail = viewH - padTop - padBottom;
      var delta = 0;

      if (rect.height <= avail) {
        if (rect.top < padTop) {
          delta = rect.top - padTop;
        } else if (rect.bottom > viewH - padBottom) {
          delta = rect.bottom - (viewH - padBottom);
        }
      } else {
        delta = rect.top - padTop;
      }

      if (Math.abs(delta) > 1) {
        window.scrollBy({ top: delta, behavior: behavior });
      }
    }, delay);
  }

  function initFormula(formulaRoot) {
    if (!formulaRoot) return;

    var filterRoot = formulaRoot.querySelector('[data-ingredients-filter]');
    var cardsRoot = formulaRoot.querySelector('[data-collapsible-cards]');
    var bubble = document.getElementById('v4-ingredient-bubble');
    if (!filterRoot || !cardsRoot || !bubble) return;

    var cards = Array.prototype.slice.call(
      formulaRoot.querySelectorAll('.card-collapsible--bubble'),
    );
    var tabButtons = Array.prototype.slice.call(
      filterRoot.querySelectorAll('.tabs-button[data-filter]'),
    );
    var showMore = formulaRoot.querySelector('[data-show-more]');
    var showLess = formulaRoot.querySelector('[data-show-less]');
    var moreWrap = formulaRoot.querySelector('.collapsible-cards__more');
    var countEl = formulaRoot.querySelector('[data-ingredient-count]');
    var jsonUrl = filterRoot.getAttribute('data-ingredient-json');

    var limit = Number(cardsRoot.getAttribute('data-show-more-limit') || '9');
    var expanded = false;
    var activeFilter = 'all';
    var activeSlug = null;
    var detailsCache = null;
    var totalCount = cards.length;

    function visibleCards() {
      return cards.filter(function (card) {
        return !card.hasAttribute('hidden');
      });
    }

    function updateCount() {
      if (!countEl) return;
      var visible = visibleCards();
      var shown = expanded ? visible.length : Math.min(limit, visible.length);
      countEl.textContent = 'Showing ' + shown + ' of ' + totalCount + ' ingredients';
    }

    function syncCollapsed() {
      var visible = visibleCards();
      visible.forEach(function (card, index) {
        var collapse = !expanded && index >= limit;
        card.classList.toggle('is-collapsed-hidden', collapse);
      });
      cards.forEach(function (card) {
        if (card.hasAttribute('hidden')) {
          card.classList.remove('is-collapsed-hidden');
        }
      });

      var canCollapse = visible.length > limit;
      if (moreWrap) moreWrap.hidden = !canCollapse;
      if (showMore) {
        var hiddenCount = Math.max(0, visible.length - limit);
        showMore.hidden = !canCollapse || expanded;
        if (hiddenCount > 0) {
          showMore.textContent = 'Show ' + hiddenCount + ' more ingredients';
        }
      }
      if (showLess) showLess.hidden = !canCollapse || !expanded;
      updateCount();
    }

    function setActiveSlug(slug) {
      activeSlug = slug;

      cards.forEach(function (card) {
        var on = slug && card.getAttribute('data-ingredient-slug') === slug;
        card.setAttribute('data-active', on ? 'true' : 'false');
        var trigger = card.querySelector('.card-collapsible__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
      });

      if (slug) {
        cardsRoot.setAttribute('data-bubble-open', 'true');
        bubble.setAttribute('data-open', 'true');
        bubble.setAttribute('aria-hidden', 'false');
        renderBubble(slug);
        scrollBubbleIntoView(bubble);
        return;
      }

      cardsRoot.setAttribute('data-bubble-open', 'false');
      bubble.setAttribute('data-open', 'false');
      bubble.setAttribute('aria-hidden', 'true');
      bubble.innerHTML = '';
    }

    function renderBubble(slug) {
      if (!detailsCache || !detailsCache.details) return;
      var detail = detailsCache.details[slug];
      if (!detail) return;

      var cardEl = formulaRoot.querySelector('[data-ingredient-slug="' + slug + '"]');
      var imgEl = cardEl && cardEl.querySelector('.card-collapsible__plate img');
      var imgSrc = (imgEl && imgEl.getAttribute('src')) || '';

      var latin = detail.latin || '';
      if (!latin && detailsCache.stickerBySlug && detailsCache.stickerBySlug[slug]) {
        latin = detailsCache.stickerBySlug[slug].latin || '';
      }
      if (!latin && cardEl) {
        var titleText = cardEl.querySelector('.card-collapsible__title');
        if (titleText && titleText.textContent.indexOf('Lactobacillus') === 0) {
          /* latin comes from JSON when present */
        }
      }

      var body = (detail.paragraphs || [])
        .map(function (p) {
          return '<p>' + p + '</p>';
        })
        .join('');

      var citations = (detail.citations || [])
        .map(function (c) {
          return (
            '<li><a href="' +
            c.url +
            '" target="_blank" rel="noopener noreferrer" aria-label="See study, PubMed ID ' +
            c.pmid +
            ', opens in new tab">See study <span aria-hidden="true">\u2197</span><span class="v4-ingredient-bubble__pmid">PMID ' +
            c.pmid +
            '</span></a></li>'
          );
        })
        .join('');

      bubble.innerHTML =
        '<article class="v4-ingredient-bubble__card v4-ingredient-bubble__card--' +
        detail.group +
        '" role="region" aria-labelledby="v4-ingredient-bubble-name">' +
        '<button type="button" class="v4-ingredient-bubble__close" aria-label="Close ingredient detail">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">' +
        '<line x1="2" y1="2" x2="12" y2="12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '<line x1="12" y1="2" x2="2" y2="12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '</svg></button>' +
        (imgSrc
          ? '<span class="v4-ingredient-bubble__plate" aria-hidden="true"><img src="' +
            imgSrc +
            '" alt="" loading="lazy" width="200" height="200"></span>'
          : '') +
        '<div class="v4-ingredient-bubble__content">' +
        '<p class="v4-ingredient-bubble__group-label"><span aria-hidden="true">\u25CF</span> ' +
        detail.groupLabel +
        (detail.unique ? ' <span class="v4-ingredient-bubble__badge">Unique to BC</span>' : '') +
        '</p>' +
        '<h3 id="v4-ingredient-bubble-name" class="v4-ingredient-bubble__name">' +
        detail.fullName +
        (latin ? '<em class="v4-ingredient-bubble__latin">' + latin + '</em>' : '') +
        '</h3>' +
        '<p class="v4-ingredient-bubble__dose">' +
        detail.dose +
        '</p>' +
        '<p class="v4-ingredient-bubble__lead">' +
        detail.lead +
        '</p>' +
        '<div class="v4-ingredient-bubble__body">' +
        body +
        '</div>' +
        (citations ? '<ul class="v4-ingredient-bubble__citations">' + citations + '</ul>' : '') +
        '</div></article>';

      bubble.querySelector('.v4-ingredient-bubble__close').addEventListener('click', function () {
        setActiveSlug(null);
      });
    }

    function applyFilter(filter) {
      activeFilter = filter;
      tabButtons.forEach(function (button) {
        button.classList.toggle('is-active', button.getAttribute('data-filter') === filter);
      });
      cards.forEach(function (card) {
        var categories = (card.getAttribute('data-ingredient-categories') || '').split(/\s+/);
        var match = filter === 'all' || categories.indexOf(filter) >= 0;
        if (match) {
          card.removeAttribute('hidden');
        } else {
          card.setAttribute('hidden', '');
        }
      });
      expanded = false;
      setActiveSlug(null);
      syncCollapsed();
    }

    filterRoot.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var tab = target.closest('.tabs-button[data-filter]');
      if (tab && filterRoot.contains(tab)) {
        event.preventDefault();
        applyFilter(tab.getAttribute('data-filter') || 'all');
        return;
      }

      if (showMore && target.closest('[data-show-more]')) {
        event.preventDefault();
        expanded = true;
        syncCollapsed();
        return;
      }

      if (showLess && target.closest('[data-show-less]')) {
        event.preventDefault();
        expanded = false;
        syncCollapsed();
        return;
      }

      var trigger = target.closest('.card-collapsible__trigger[data-ingredient-slug]');
      if (!trigger || !formulaRoot.contains(trigger)) return;
      event.preventDefault();
      var slug = trigger.getAttribute('data-ingredient-slug') || '';
      if (!slug || !detailsCache || !detailsCache.details || !detailsCache.details[slug]) return;
      setActiveSlug(activeSlug === slug ? null : slug);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activeSlug) setActiveSlug(null);
    });

    if (jsonUrl) {
      fetch(jsonUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('ingredient JSON ' + res.status);
          return res.json();
        })
        .then(function (data) {
          detailsCache = data;
        })
        .catch(function () {
          /* cards stay clickable only when JSON loads */
        });
    }

    applyFilter('all');
  }

  function boot() {
    initFormula(document.getElementById('formula'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
